/* eslint-disable */
export default {
  sureToDeleteVoiceMail: '¿Confirma que desea eliminar este mensaje de voz?',
  sureToDeleteFax: '¿Confirma que desea eliminar este fax?',
  doNotAskAgain: 'No preguntarme de nuevo',
} as const;

// @key: @#@"sureToDeleteVoiceMail"@#@ @source: @#@"Are you sure you want to delete this voicemail?"@#@
// @key: @#@"sureToDeleteFax"@#@ @source: @#@"Are you sure you want to delete this fax?"@#@
// @key: @#@"doNotAskAgain"@#@ @source: @#@"Don't ask me again"@#@
